(function () {
    "use strict";

    angular
        .module('blocks.modal')
        .directive('obtModalPopups', obtModalPopups);

    /*@ngInject*/
    function obtModalPopups() {
        return {
            restrict: 'E',
            scope: {
                openModalPromise: '=',
                title: '@'
            },
            controller: obtModalPopupsCtrl
        }
    }

    obtModalPopupsCtrl.$inject=['$scope', 'obtModalService'];
    /*@ngInject*/
    function obtModalPopupsCtrl ($scope, obtModalService) {
        var vm = this;
        $scope.openModalPromise = openModal;
        vm.addModalOption = addModalOption;
        var modalOptions = null;

        function addModalOption (option) {
            if (option) {
                if (!modalOptions) {
                    modalOptions = [];
                }
                modalOptions.push(option);
            }
        }

        function openModal(calEvent, closeCallback) {
            var settings = getModalSettings(calEvent, closeCallback);
            return obtModalService.openModal(settings).result;
        }

        function getModalSettings(calEvent, closeCallback){
            var settings = {
                templateUrl: 'app/blocks/modal/obt-modals.directive.html',
                controller:'modalsController',
                controllerAs: 'vmModalPopups'
            };

            settings.resolve = settings.resolve ? settings.resolve : {};
            settings.resolve.modalModel = function(){return calEvent};
            settings.resolve.modalSettings = function(){
                return {
                    closeCallback: closeCallback,
                    options:modalOptions,
                    title:$scope.title
                }};

//                    settings.callbackSuccess = callbackSuccess;
            settings.callbackFailed = callbackFailed;

            return settings;
        }
        function callbackSuccess (selectedItem) {}
        function callbackFailed () {
//                    toaster.pop('error', "Error", "error raised during process");
        }
    }
})();


/*****************
 ** WEBPACK FOOTER
 ** ./app/blocks/modal/obt-modals.directive.js
 ** module id = 90
 ** module chunks = 0
 **/